const AMAZON = [
  ["6 %", "Mode, chaussures, montres, luxe"],
  ["5 %", "Meubles, maison, cuisine, bricolage, livres"],
  ["4 %", "Beauté, sport, bagages, soins"],
  ["3 %", "Informatique, high-tech, jouets, autres"],
  ["2,5 %", "Électronique mobile, gros électroménager"],
  ["1 %", "Épicerie, jeux vidéo"],
];

const SOFT = [
  ["Systeme.io", "60 % de l'abonnement, chaque mois, à vie", "Le plus rentable : un client à 27 €/mois vous rapporte environ 16 €/mois"],
  ["Hostinger", "À partir de 40 % par vente", "Panier moyen élevé (hébergement sur 1 à 4 ans)"],
  ["Kit", "50 % pendant 12 mois", "Pour un public de créateurs et de newsletters"],
];

const OTHERS = [
  ["ManoMano (via Awin)", "Jusqu'à 10 % · cookie 10 jours", "Maison, jardin, bricolage"],
  ["Cdiscount (via Awin)", "Jusqu'à 8 % · cookie 7 jours", "Tout le bazar, panier moyen ~130 €"],
];

const Card = ({ title, children, id }) => (
  <div data-testid={id} className="rounded-[20px] border border-[var(--line)] bg-white p-6">
    <h3 className="font-display text-xl">{title}</h3>
    <div className="mt-4 text-sm">{children}</div>
  </div>
);

export const MarginGuide = () => (
  <section data-testid="admin-margin-guide" className="mt-16">
    <h2 className="font-display text-2xl">Guide des marges partenaires</h2>
    <p className="mt-1 text-sm text-[var(--muted)]">Taux indicatifs relevés en 2026 sur les pages des programmes. Vérifiez toujours le barème dans votre espace partenaire : les taux peuvent changer.</p>
    <div className="mt-6 grid gap-4 lg:grid-cols-3">
      <Card id="guide-amazon" title="Amazon Partenaires">
        <ul className="space-y-2">{AMAZON.map(([r, c]) => <li key={r} className="flex gap-3"><span className="w-12 shrink-0 font-semibold text-[var(--terra-deep)]">{r}</span><span className="text-[var(--muted)]">{c}</span></li>)}</ul>
        <p className="mt-4 text-xs text-[var(--muted)]">Cookie 24 h : vous touchez une commission sur tout le panier du client dans les 24 h, pas seulement sur le produit cliqué. Paiement dès 25 €.</p>
      </Card>
      <Card id="guide-software" title="Logiciels : les plus grosses marges">
        <ul className="space-y-3">{SOFT.map(([n, r, t]) => <li key={n}><p className="font-semibold">{n} · <span className="text-[var(--terra-deep)]">{r}</span></p><p className="text-xs text-[var(--muted)]">{t}</p></li>)}</ul>
      </Card>
      <Card id="guide-others" title="Pour aller plus loin">
        <ul className="space-y-3">{OTHERS.map(([n, r, t]) => <li key={n}><p className="font-semibold">{n}</p><p className="text-xs text-[var(--muted)]">{r} · {t}</p></li>)}</ul>
        <p className="mt-4 text-xs text-[var(--muted)]">Conseil : ce sont les gros paniers (meubles, bureau assis-debout, machine à café : 5 %) et les abonnements logiciels qui rapportent le plus. Les petits accessoires (câbles, carnets) apportent du volume.</p>
      </Card>
    </div>
  </section>
);
